export default function GoodCompany() {
    return (
        <span className="sidebar-component">
            <div className="sidebar-component-container trustpilot-badge">
                <a
                    href="https://www.trustpilot.com/review/constructaquote.com?utm_medium=Trustbox&utm_source=EmailSignature4"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="trustpilot-link"
                >
                    <img
                        src="https://emailsignature.trustpilot.com/signature/en-US/4/5ca7ac0c52585d00018f9f89/text.png"
                        className="trustpilot-img"
                        alt="Trustpilot Human score"
                    />
                </a>

                <a
                    href="https://www.trustpilot.com/review/constructaquote.com?utm_medium=Trustbox&utm_source=EmailSignature4"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="trustpilot-link"
                >
                    <img
                        src="https://emailsignature.trustpilot.com/signature/en-US/4/5ca7ac0c52585d00018f9f89/stars.png"
                        className="trustpilot-img"
                        alt="Trustpilot Stars"
                    />
                </a>

                <a
                    href="https://www.trustpilot.com/review/constructaquote.com?utm_medium=Trustbox&utm_source=EmailSignature4"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="trustpilot-link"
                >
                    <img
                        src="https://emailsignature.trustpilot.com/brand/s/4/logo.png"
                        className="trustpilot-img"
                        alt="Trustpilot Logo"
                    />
                </a>
            </div>
        </span>
    );
}